import { takeLatest, put, select } from 'redux-saga/effects';
import localStorage from '@utils/localStorage';
import selector from './selectors';
import { CURRENT_PRODUCT_MODE } from '@utils/constants';
import { selectedCustomerIdSelector } from '../common/selectors';
import * as types from './types';
import { message } from 'antd';
import { CLOSE_ALL_TABS } from '@store/common/types';

const productKey = CURRENT_PRODUCT_MODE === 'EI' ? '_' : `_${CURRENT_PRODUCT_MODE.toLowerCase()}_`;

const sharedTabsKeyPrefix = `sharedTabs${productKey}`;
const limit = Number.MAX_SAFE_INTEGER; // Don't limit the tabs for now.

function* init(action) {
  let customerId = yield select(selectedCustomerIdSelector);
  if (customerId === -1) {
    customerId = action.selectedCustomerId;
  }
  const sharedTabsKey = `${sharedTabsKeyPrefix}${customerId}`;
  const tabs = localStorage.get(sharedTabsKey) || [];
  yield put({
    type: types.UPDATE_SHARED_TABS,
    newTabs: tabs,
  });
}

function* watchInit() {
  yield takeLatest([types.INIT], init);
}

function* updateSharedTab(action) {
  let { selectedCustomerId } = action;
  const { newTab } = action;
  if (!selectedCustomerId) {
    selectedCustomerId = yield select(selectedCustomerIdSelector);
  }
  const sharedTabsKey = `${sharedTabsKeyPrefix}${selectedCustomerId}`;
  yield init({ selectedCustomerId });
  const { tabs } = yield select(selector);
  let newTabs = [...tabs];
  const index = newTabs.findIndex((item) => item.id === newTab.id);
  // Insert newTab into tabs array if we can not find it, or we need to modify the existed element.
  if (index === -1) {
    // If the length of data is bigger than limitation, we need to delete the oldest one(the fisrt one) and push the new one in
    if (tabs.length >= limit) {
      const [_, ...res] = newTabs;
      newTabs = [...res, newTab];
    } else {
      newTabs = [...tabs, newTab]; // just push newTab when the length is not overflow
    }
  } else {
    newTabs[index] = newTab; // modify the existed element if we already have it.
  }

  localStorage.set({ key: sharedTabsKey, value: newTabs, expires: null });
  yield put({
    type: types.UPDATE_SHARED_TABS,
    newTabs,
  });
}

function* watchAddNewTab() {
  yield takeLatest([types.ADD_NEW_SHARED_TAB], updateSharedTab);
}

function* deleteSharedTab(action) {
  const customerId = yield select(selectedCustomerIdSelector);
  const sharedTabsKey = `${sharedTabsKeyPrefix}${customerId}`;
  const { tabs } = yield select(selector);
  const { id } = action;
  const { showMessage } = action;
  const newTabs = tabs.filter((item) => item.id !== id);

  localStorage.set({ key: sharedTabsKey, value: newTabs, expires: null });
  yield put({
    type: types.UPDATE_SHARED_TABS,
    newTabs,
  });
  if (showMessage) {
    message.success('Delete successfully!');
  }
}

function* watchDeleteSharedTab() {
  yield takeLatest([types.DELETE_SHARED_TAB], deleteSharedTab);
}

function* closeAllSharedTabs(action) {
  const customerId = yield select(selectedCustomerIdSelector);
  const sharedTabsKey = `${sharedTabsKeyPrefix}${customerId}`;
  localStorage.remove(sharedTabsKey);
  yield init(action);
}

function* watchCloseAllTabs() {
  yield takeLatest(CLOSE_ALL_TABS, closeAllSharedTabs);
}

export default [watchInit, watchAddNewTab, watchDeleteSharedTab, watchCloseAllTabs];
